import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Clock } from "lucide-react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Footer = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(`${API}/categories`);
        setCategories(res.data);
      } catch (e) {
        console.error("Error fetching categories:", e);
      }
    };
    fetchCategories();
  }, []);

  return (
    <footer className="bg-card border-t border-border mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <h2 className="font-unbounded text-2xl font-bold gradient-text mb-4">
              AIRO VAPOR
            </h2>
            <p className="font-outfit text-sm text-muted-foreground">
              Premium vaporizers and e-liquids. Quality products for the
              discerning enthusiast.
            </p>
          </div>

          {/* Shop Categories - Dynamic */}
          <div>
            <h3 className="font-unbounded text-sm font-semibold text-foreground mb-4 uppercase tracking-wider">
              Shop
            </h3>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.id || cat.slug}>
                  <Link
                    to={`/shop/${cat.slug || cat.id}`}
                    className="font-outfit text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-unbounded text-sm font-semibold text-foreground mb-4 uppercase tracking-wider">
              Company
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="font-outfit text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="font-outfit text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-unbounded text-sm font-semibold text-foreground mb-4 uppercase tracking-wider">
              Visit Us
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-primary mt-1 flex-shrink-0" />
                <span className="font-outfit text-sm text-muted-foreground">
                  1823 E Santa Fe St
                  <br />
                  Gardner, KS 66030
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-primary flex-shrink-0" />
                <a
                  href="tel:+19136051001"
                  className="font-outfit text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  (913) 605-1001
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Clock className="w-4 h-4 text-primary flex-shrink-0" />
                <span className="font-outfit text-sm text-muted-foreground">
                  Daily: 10 AM - 8 PM
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-outfit text-sm text-muted-foreground text-center md:text-left">
            © 2025 Airo Vapor. All rights reserved.
          </p>
          <p className="font-outfit text-xs text-muted-foreground text-center">
            WARNING: This product contains nicotine. Nicotine is an addictive
            chemical.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
